import type { TSavedFilter, TSavedFilterValues } from "@/zapi-frontend/shared/types/savedFilters";

function normalize(values: TSavedFilterValues): Map<string, Set<string>> {
  const out = new Map<string, Set<string>>();
  for (const [k, arr] of Object.entries(values)) {
    if (!arr || arr.length === 0) continue;
    out.set(k, new Set(arr));
  }
  return out;
}

function sameSet(a: Set<string>, b: Set<string>): boolean {
  if (a.size !== b.size) return false;
  for (const v of a) if (!b.has(v)) return false;
  return true;
}

export function filtersEqual(a: TSavedFilterValues, b: TSavedFilterValues): boolean {
  const na = normalize(a);
  const nb = normalize(b);
  if (na.size !== nb.size) return false;
  for (const [k, set] of na) {
    const other = nb.get(k);
    if (!other || !sameSet(set, other)) return false;
  }
  return true;
}

export function findMatchingSavedFilter(
  list: TSavedFilter[],
  activeFilters: TSavedFilterValues
): TSavedFilter | null {
  for (const f of list) {
    if (filtersEqual(f.filters, activeFilters)) return f;
  }
  return null;
}

export function isFiltersEmpty(values: TSavedFilterValues): boolean {
  for (const arr of Object.values(values)) {
    if (arr && arr.length > 0) return false;
  }
  return true;
}
